export default __webpack_public_path__ + "static/Fly9-efa28a15423bf22fef34228ee0582ccb.mp3";